
import { Product } from './types';

export const PRODUCTS: Product[] = [
  // LYNSEY FAVORITES
  {
    id: 'fav-1',
    name: "Bicarb",
    category: 'Lynsey Favorites',
    price: 4.99,
    description: "The miracle cleaner! I use bicarb for everything. It's a must-have in every home.",
    image: 'https://m.media-amazon.com/images/I/61d-+c2zghL._AC_SX679_.jpg',
    rating: 5.0,
    reviewCount: 4500,
    tags: ['Miracle'],
    url: 'https://amzlink.to/az0jGBsukOl7V',
    inStock: true,
    company: 'Amazon',
    asin: 'B0027ICKCY'
  },
  {
    id: 'fav-2',
    name: "Method Floor Cleaner",
    category: 'Lynsey Favorites',
    price: 5.50,
    description: "My go-to for floors. The smell is iconic and it cleans so beautifully without chemicals.",
    image: 'https://m.media-amazon.com/images/I/51EyxA7YrzL._AC_SX679_.jpg',
    rating: 4.9,
    reviewCount: 2800,
    tags: ['Iconic'],
    url: 'https://amzlink.to/az0Ggjben76No',
    inStock: true,
    company: 'Amazon',
    asin: 'B07HDPVVSB'
  },
  {
    id: 'fav-3',
    name: "Sponges",
    category: 'Lynsey Favorites',
    price: 3.99,
    description: "Quality sponges that last. Don't settle for flimsy ones that fall apart, love!",
    image: 'https://m.media-amazon.com/images/I/713ue13EfuL._AC_SX679_.jpg',
    rating: 4.7,
    reviewCount: 620,
    tags: ['Quality'],
    url: 'https://amzlink.to/az0bfdjknw9sO',
    inStock: true,
    company: 'Amazon',
    asin: 'B00RZT81HI'
  },
  {
    id: 'fav-4',
    name: "Pet Brush",
    category: 'Lynsey Favorites',
    price: 14.99,
    description: "Keep your furry friends groomed and your house hair-free. This brush is simply the best!",
    image: 'https://m.media-amazon.com/images/I/71epU4sAVBL._AC_SX679_.jpg',
    rating: 4.8,
    reviewCount: 1200,
    tags: ['Pets'],
    url: 'https://amzlink.to/az03N5EhkOAFb',
    inStock: true,
    company: 'Amazon',
    asin: 'B07XF5Y8ZT'
  },

  // BOOKS
  {
    id: 'book-1',
    name: "The 15-Minute Clean",
    category: 'Books',
    price: 8.95,
    description: "My best-selling guide to transforming your home in just 15 minutes a day. You can do it, love!",
    image: 'https://m.media-amazon.com/images/I/81a4bum7NxL._SY522_.jpg',
    rating: 4.9,
    reviewCount: 1240,
    tags: ['Bestseller'],
    url: 'https://www.amazon.com/dp/B093WXLPZY?tag=queenof-21&linkCode=osi&th=1&psc=1',
    inStock: true,
    company: 'Amazon',
    asin: 'B093WXLPZY'
  },
  {
    id: 'book-2',
    name: "How To Clean Your House",
    category: 'Books',
    price: 11.95,
    description: "The ultimate manual for every room. Packed with natural cleaning hacks and my top secrets!",
    image: 'https://m.media-amazon.com/images/I/61Di4FTimSL._SY522_.jpg',
    rating: 4.8,
    reviewCount: 856,
    tags: ['Manual'],
    url: 'https://www.amazon.com/dp/000834194X?tag=queenof-21&linkCode=osi&th=1&psc=1',
    inStock: true,
    company: 'Amazon',
    asin: '000834194X'
  },
  {
    id: 'book-3',
    name: "The Easy Life",
    category: 'Books',
    price: 9.16,
    description: "Simplify your chores and reclaim your free time. This book shows you the path to a stress-free routine!",
    image: 'https://m.media-amazon.com/images/I/71pWngfbCoL._SY522_.jpg',
    rating: 4.7,
    reviewCount: 532,
    tags: ['Simplify'],
    url: 'https://www.amazon.com/dp/178739414X?tag=queenof-21&linkCode=osi&th=1&psc=1',
    inStock: true,
    company: 'Amazon',
    asin: '178739414X'
  },

  // CLEANING TOOLS
  {
    id: 'tool-1',
    name: "Scrub Daddy 6 Scrub Mommy Kitchen Sponges",
    category: 'Cleaning Tools',
    price: 15.99,
    description: "A kitchen essential! These smileys change texture in water and make washing up actually fun.",
    image: 'https://m.media-amazon.com/images/I/61sGVXDON2L._AC_SX679_.jpg',
    rating: 5.0,
    reviewCount: 2450,
    tags: ['Essential'],
    url: 'https://www.amazon.com/dp/B0CJVQZ6CB?tag=queenof-21&linkCode=osi&th=1',
    inStock: true,
    company: 'Amazon',
    asin: 'B0CJVQZ6CB'
  },
  {
    id: 'tool-2',
    name: "Oxy Power Stain Remover Powder",
    category: 'Cleaning Tools',
    price: 8.50,
    description: "Lift those stubborn stains with ease. Perfect for whites and colors to keep them looking fresh.",
    image: 'https://m.media-amazon.com/images/I/719GVhld1hL._AC_SX425_.jpg',
    rating: 4.8,
    reviewCount: 680,
    tags: ['Stains'],
    url: 'https://amzlink.to/az0w8mPQ8Ned7',
    inStock: true,
    company: 'Amazon',
    asin: 'B0D5QSPJBK'
  },
  {
    id: 'tool-3',
    name: "Eco White Vinegar",
    category: 'Cleaning Tools',
    price: 6.99,
    description: "The natural way to clean! My favorite eco-friendly tool for glass, counters, and so much more.",
    image: 'https://m.media-amazon.com/images/I/71Rgwo6d2lL._AC_SX679_.jpg',
    rating: 4.9,
    reviewCount: 1100,
    tags: ['Natural'],
    url: 'https://amzlink.to/az0qVZCL9LjmQ',
    inStock: true,
    company: 'Amazon',
    asin: 'B0BN417VKH'
  },
  {
    id: 'tool-4',
    name: "Washing Machine Cleaner",
    category: 'Cleaning Tools',
    price: 7.99,
    description: "Don't forget the machine that cleans your clothes! Keep it smelling fresh and working perfectly.",
    image: 'https://m.media-amazon.com/images/I/61ArfBhiU3L._AC_SX679_.jpg',
    rating: 4.7,
    reviewCount: 890,
    tags: ['Maintenance'],
    url: 'https://amzlink.to/az0HCqL2bjvYz',
    inStock: true,
    company: 'Amazon',
    asin: 'B0080ZSQKS'
  },

  // MAKE UP
  {
    id: 'makeup-1',
    name: "Catrice Under Eye Brightener",
    category: 'Make Up',
    price: 4.99,
    description: "My little secret for looking fresh even after a long day of cleaning! Brightens beautifully, love.",
    image: 'https://m.media-amazon.com/images/I/618TAd+pHqL._AC_SX425_.jpg',
    rating: 4.9,
    reviewCount: 890,
    tags: ['Beauty'],
    url: 'https://amzlink.to/az0I29GJjEdQY',
    inStock: true,
    company: 'Amazon',
    asin: 'B09V1CPTR1'
  },
  {
    id: 'makeup-new-1',
    name: "Flawless Filter",
    category: 'Make Up',
    price: 39.00,
    description: "Get that famous glow! Perfect for a radiant, fresh-faced look every single day.",
    image: 'https://images.ctfassets.net/wlke2cbybljx/49YlBdOgyo385hjaUjESlp/f854866661dfed9d6a1003482e582cec/HFF-PACKSHOT-OPEN-4.5.png?q=80&w=660&h=660&fit=fill&bg=&fm=webp',
    rating: 4.9,
    reviewCount: 1540,
    tags: ['Glow'],
    url: 'https://go.shopmy.us/p-39256653',
    inStock: true,
    company: 'Charlotte Tilbury'
  },
  {
    id: 'makeup-new-2',
    name: "Face Primer",
    category: 'Make Up',
    price: 35.00,
    description: "The perfect base for your makeup. Keeps everything in place while you're busy making things sparkle!",
    image: 'https://www.spacenk.com/dw/image/v2/ABCE_PRD/on/demandware.static/-/Sites-spacenkmastercatalog/default/dw8f5616d4/products/CHARLOTTE/UK200026034_CHARLOTTE.jpg?sw=582&sh=582',
    rating: 4.8,
    reviewCount: 920,
    tags: ['Base'],
    url: 'https://go.shopmy.us/p-39256763',
    inStock: true,
    company: 'Space NK'
  },
  {
    id: 'makeup-new-3',
    name: "Lip Oil Gloss",
    category: 'Make Up',
    price: 22.00,
    description: "Hydrating and shiny! A little touch of luxury for your lips, darling.",
    image: 'https://www.spacenk.com/dw/image/v2/ABCE_PRD/on/demandware.static/-/Sites-spacenkmastercatalog/default/dwd4e50c43/products/KOSAS/UK200037683_KOSAS.jpg?sw=582&sh=582',
    rating: 4.7,
    reviewCount: 650,
    tags: ['Gloss'],
    url: 'https://go.shopmy.us/p-39257064',
    inStock: true,
    company: 'Space NK'
  },
  {
    id: 'makeup-new-4',
    name: "Lip Booster",
    category: 'Make Up',
    price: 24.00,
    description: "Give your lips a little boost with this nourishing formula. Simply gorgeous!",
    image: 'https://www.spacenk.com/dw/image/v2/ABCE_PRD/on/demandware.static/-/Sites-spacenkmastercatalog/default/dw1164610c/products/KOSAS/UK200037775_KOSAS.jpg?sw=582&sh=582',
    rating: 4.8,
    reviewCount: 430,
    tags: ['Plump'],
    url: 'https://go.shopmy.us/p-39257271',
    inStock: true,
    company: 'Space NK'
  },
  {
    id: 'makeup-new-5',
    name: "Eye Shadow",
    category: 'Make Up',
    price: 18.00,
    description: "Beautiful shades that blend like a dream. Perfect for any occasion.",
    image: 'https://www.lookfantastic.com/images?url=https://static.thcdn.com/productimg/original/15063511-1555234608755144.jpg&format=webp&auto=avif&width=985&height=985&fit=cover',
    rating: 4.6,
    reviewCount: 310,
    tags: ['Eyes'],
    url: 'https://go.shopmy.us/p-39257443',
    inStock: true,
    company: 'Look Fantastic'
  },
  {
    id: 'makeup-new-6',
    name: "Setting Powder",
    category: 'Make Up',
    price: 28.00,
    description: "Lock in your look! This powder gives a flawless finish that lasts all day.",
    image: 'https://www.lookfantastic.com/images?url=https://static.thcdn.com/productimg/original/11220312-1915230818146952.jpg&format=webp&auto=avif&width=985&height=985&fit=cover',
    rating: 4.9,
    reviewCount: 1100,
    tags: ['Finish'],
    url: 'https://go.shopmy.us/p-39257525',
    inStock: true,
    company: 'Look Fantastic'
  },
  {
    id: 'makeup-new-7',
    name: "Mascara",
    category: 'Make Up',
    price: 15.00,
    description: "Long, luscious lashes in an instant. A makeup bag essential!",
    image: 'https://www.lookfantastic.com/images?url=https://static.thcdn.com/productimg/original/12765086-3255256174959631.jpg&format=webp&auto=avif&width=985&height=985&fit=cover',
    rating: 4.7,
    reviewCount: 890,
    tags: ['Lashes'],
    url: 'https://go.shopmy.us/p-39257890',
    inStock: true,
    company: 'Look Fantastic'
  },
  {
    id: 'makeup-new-8',
    name: "Instant Blur",
    category: 'Make Up',
    price: 45.00,
    description: "Blur away imperfections with this miracle primer. It's like a filter in a jar!",
    image: 'https://www.facethefuture.co.uk/cdn/shop/files/Perricone-MD-No-Makeup-Instant-Blur-Priming-Moisturizer.jpg?v=1708436874&width=600',
    rating: 4.9,
    reviewCount: 520,
    tags: ['Blur'],
    url: 'https://go.shopmy.us/p-39340754',
    inStock: true,
    company: 'Face The Future'
  },
  {
    id: 'makeup-new-9',
    name: "SPF 50",
    category: 'Make Up',
    price: 32.00,
    description: "Protect your skin while you glow. High protection that feels lightweight, love.",
    image: 'https://www.cultbeauty.co.uk/images?url=https://static.thcdn.com/productimg/original/13313743-5795257983812988.jpg&format=webp&auto=avif&width=985&height=985&fit=cover',
    rating: 4.8,
    reviewCount: 740,
    tags: ['Sun Protection'],
    url: 'https://go.shopmy.us/p-39340860',
    inStock: true,
    company: 'Cult Beauty'
  },
  {
    id: 'makeup-new-10',
    name: "Blush",
    category: 'Make Up',
    price: 24.00,
    description: "A pop of color for your cheeks! This Rare Beauty blush is my absolute favorite.",
    image: 'https://www.spacenk.com/dw/image/v2/ABCE_PRD/on/demandware.static/-/Sites-spacenkmastercatalog/default/dw531d6699/products/RARE/UK200048728_RARE.jpg?sw=582&sh=582',
    rating: 5.0,
    reviewCount: 2300,
    tags: ['Cheeks'],
    url: 'https://go.shopmy.us/p-39340958',
    inStock: true,
    company: 'Space NK'
  },
  {
    id: 'makeup-new-11',
    name: "Blush (Cult)",
    category: 'Make Up',
    price: 25.00,
    description: "Another gorgeous blush option. Gives such a healthy, natural flush to the skin.",
    image: 'https://www.cultbeauty.co.uk/images?url=https://static.thcdn.com/productimg/original/13317823-1125257503935805.jpg&format=webp&auto=avif&width=985&height=985&fit=cover',
    rating: 4.7,
    reviewCount: 410,
    tags: ['Glow'],
    url: 'https://go.shopmy.us/p-39341037',
    inStock: true,
    company: 'Cult Beauty'
  },
  {
    id: 'makeup-new-12',
    name: "Tinted Serum",
    category: 'Make Up',
    price: 36.00,
    description: "Skincare meets makeup! This serum gives light coverage while nourishing your skin.",
    image: 'https://www.lookfantastic.com/images?url=https://static.thcdn.com/productimg/original/13027870-4155255893732665.jpg&format=webp&auto=avif&width=985&height=985&fit=cover',
    rating: 4.8,
    reviewCount: 680,
    tags: ['Serum'],
    url: 'https://go.shopmy.us/p-39341149',
    inStock: true,
    company: 'Look Fantastic'
  },
  {
    id: 'makeup-new-13',
    name: "Serum Concealer",
    category: 'Make Up',
    price: 28.00,
    description: "Perfect for covering those tired eyes. Light, hydrating, and works like a charm.",
    image: 'https://www.lookfantastic.com/images?url=https://static.thcdn.com/productimg/original/15216230-6835247600102765.jpg&format=webp&auto=avif&width=985&height=985&fit=cover',
    rating: 4.7,
    reviewCount: 320,
    tags: ['Conceal'],
    url: 'https://go.shopmy.us/p-39341262',
    inStock: true,
    company: 'Look Fantastic'
  },
  {
    id: 'makeup-new-14',
    name: "Lip Liner",
    category: 'Make Up',
    price: 12.00,
    description: "Define your lips perfectly. Stays put all day, even through a cup of tea!",
    image: 'https://www.lookfantastic.com/images?url=https://static.thcdn.com/productimg/1600/1600/11530500-2044696096946487.jpg&format=webp&auto=avif&width=985&height=985&fit=cover',
    rating: 4.6,
    reviewCount: 540,
    tags: ['Lips'],
    url: 'https://go.shopmy.us/p-41482048',
    inStock: true,
    company: 'Look Fantastic'
  },
  {
    id: 'makeup-new-15',
    name: "Mascara (Boots)",
    category: 'Make Up',
    price: 14.00,
    description: "A high-street hero! This mascara gives amazing volume for a fraction of the price.",
    image: 'https://images.squarespace-cdn.com/content/6962244a930d3931ee04d503/51c048a4-23b3-4150-91a0-a331a9cd69ae/Boots+Mascara.png?content-type=image%2Fpng',
    rating: 4.8,
    reviewCount: 1200,
    tags: ['Volume'],
    url: 'https://go.shopmy.us/p-41482065',
    inStock: true,
    company: 'Boots'
  },
  {
    id: 'makeup-new-16',
    name: "Foundation",
    category: 'Make Up',
    price: 42.00,
    description: "Flawless coverage that still looks like skin. It's simply magic in a bottle!",
    image: 'https://images.ctfassets.net/wlke2cbybljx/5XjyYC3eHF5VjSz5jFWOo9/8b4006d6eb78976f3cd24a1d98b69349/AFF_FOUNDATION_OPEN_5N.png?q=80&w=660&h=660&fit=fill&bg=&fm=webp',
    rating: 4.9,
    reviewCount: 880,
    tags: ['Flawless'],
    url: 'https://go.shopmy.us/p-41482087',
    inStock: true,
    company: 'Charlotte Tilbury'
  },
  {
    id: 'makeup-new-17',
    name: "Miscellar Water",
    category: 'Make Up',
    price: 8.00,
    description: "Gently remove your makeup at the end of the day. Essential for a clean and happy face!",
    image: 'https://images.squarespace-cdn.com/content/6962244a930d3931ee04d503/8ba6daa2-c5fd-4c0e-8eb4-84fb4da24c8a/Screenshot+2026-02-16+at+09.00.29.png?content-type=image%2Fpng',
    rating: 4.8,
    reviewCount: 3400,
    tags: ['Cleanse'],
    url: 'https://amzlink.to/az0j1QS17TZwD',
    inStock: true,
    company: 'Amazon',
    asin: 'B01M6UUOY2'
  },
  {
    id: 'makeup-new-18',
    name: "Make Up Brushes",
    category: 'Make Up',
    price: 25.00,
    description: "Professional tools for a professional look. These brushes are soft, durable, and so effective.",
    image: 'https://m.media-amazon.com/images/I/81IR0WRsMNL._AC_SX425_.jpg',
    rating: 4.7,
    reviewCount: 1560,
    tags: ['Tools'],
    url: 'https://amzlink.to/az0ycvMZWhw4Z',
    inStock: true,
    company: 'Amazon',
    asin: 'B09VCPB6DT'
  },
  {
    id: 'makeup-new-19',
    name: "Beauty Blenders",
    category: 'Make Up',
    price: 12.00,
    description: "The secret to a seamless blend. I wouldn't be without these in my makeup kit!",
    image: 'https://m.media-amazon.com/images/I/61yITHXXqJL._AC_SL1500_.jpg',
    rating: 4.8,
    reviewCount: 920,
    tags: ['Blend'],
    url: 'https://amzlink.to/az0upDWK2tCpN',
    inStock: true,
    company: 'Amazon',
    asin: 'B07VBNQ367'
  },
  {
    id: 'makeup-new-20',
    name: "Lash Mascara",
    category: 'Make Up',
    price: 16.00,
    description: "Another fantastic mascara choice. Separates and defines for a wide-eyed look.",
    image: 'https://m.media-amazon.com/images/I/61f9qHlbUJL._AC_SL1500_.jpg',
    rating: 4.7,
    reviewCount: 430,
    tags: ['Define'],
    url: 'https://amzlink.to/az0WxDG1zG6hM',
    inStock: true,
    company: 'Amazon',
    asin: 'B000ORS6SM'
  },
  {
    id: 'makeup-new-21',
    name: "Defining Mascara",
    category: 'Make Up',
    price: 15.00,
    description: "Every lash counts! This mascara ensures you never miss a single one.",
    image: 'https://m.media-amazon.com/images/I/61gbxxk+R6L._AC_SL1500_.jpg',
    rating: 4.6,
    reviewCount: 280,
    tags: ['Lashes'],
    url: 'https://amzlink.to/az06bm2zt3fo9',
    inStock: true,
    company: 'Amazon',
    asin: 'B0DSJMFRTN'
  },
  {
    id: 'makeup-new-22',
    name: "Lip Shimmer",
    category: 'Make Up',
    price: 10.00,
    description: "Add a little sparkle to your day! This lip shimmer is subtle and so pretty.",
    image: 'https://m.media-amazon.com/images/I/61HM+rxT1AL._SL1500_.jpg',
    rating: 4.7,
    reviewCount: 190,
    tags: ['Sparkle'],
    url: 'https://amzlink.to/az0xijizT1BG2',
    inStock: true,
    company: 'Amazon',
    asin: 'B0001VKL7U'
  },
  {
    id: 'makeup-new-23',
    name: "Lip Oil Gloss (Amazon)",
    category: 'Make Up',
    price: 11.00,
    description: "Nourishing gloss at a great price. Perfect for keeping in your handbag, love.",
    image: 'https://m.media-amazon.com/images/I/71QwkVhH2KL._AC_SL1500_.jpg',
    rating: 4.8,
    reviewCount: 650,
    tags: ['Lips'],
    url: 'https://amzlink.to/az0tYzTiEyvuq',
    inStock: true,
    company: 'Amazon',
    asin: 'B0D2LGFQ11'
  },
  {
    id: 'makeup-new-24',
    name: "Lip Stain",
    category: 'Make Up',
    price: 14.00,
    description: "Color that stays! This lip stain is perfect for a long day when you don't have time to reapply.",
    image: 'https://m.media-amazon.com/images/I/71QN+W-iLzL._AC_SL1500_.jpg',
    rating: 4.9,
    reviewCount: 420,
    tags: ['Stain'],
    url: 'https://amzlink.to/az0PmvNYCFpIK',
    inStock: true,
    company: 'Amazon',
    asin: 'B0B9YHX8DX'
  },

  // FASHION
  {
    id: 'fashion-new-1',
    name: "Jumper",
    category: 'Fashion',
    price: 45.00,
    description: "Stay cozy and stylish with this beautiful jumper from Scamp & Dude. A real wardrobe essential, love!",
    image: 'https://scampanddude.com/cdn/shop/files/SCAMPANDDUDE_ECOM_JAN26_1973.jpg?v=1769086746&width=5000',
    rating: 4.9,
    reviewCount: 124,
    tags: ['Cozy', 'Scamp & Dude'],
    url: 'https://go.shopmy.us/p-42240022',
    inStock: true,
    company: 'Scamp and Dude'
  },
  {
    id: 'fashion-new-2',
    name: "Blouse",
    category: 'Fashion',
    price: 28.00,
    description: "A smart and elegant blouse for any occasion. Cleans easily and looks so fresh!",
    image: 'https://www.bonmarche.co.uk/dw/image/v2/BBCZ_PRD/on/demandware.static/-/Sites-master-catalog-bonmarche/default/dw29b5223e/zoom/90/Blouse%20901034644.jpg?sw=460&sh=690&sm=fit',
    rating: 4.7,
    reviewCount: 86,
    tags: ['Elegant'],
    url: 'https://go.shopmy.us/p-41976011',
    inStock: true,
    company: 'Bon Marche'
  },
  {
    id: 'fashion-new-3',
    name: "Sweatshirt",
    category: 'Fashion',
    price: 32.00,
    description: "The perfect casual piece for a busy day around the house. Comfortable and durable.",
    image: 'https://www.bonmarche.co.uk/dw/image/v2/BBCZ_PRD/on/demandware.static/-/Sites-master-catalog-bonmarche/default/dwdcf2a14a/zoom/90/Sweatshirt%20901071921%20(3).jpg?sw=460&sh=690&sm=fit',
    rating: 4.8,
    reviewCount: 112,
    tags: ['Casual'],
    url: 'https://go.shopmy.us/p-41975904',
    inStock: true,
    company: 'Bon Marche'
  },
  {
    id: 'fashion-new-4',
    name: "Skirt (Blue Stripe)",
    category: 'Fashion',
    price: 55.00,
    description: "Gorgeous blue and white stripes! This skirt is so flattering and brings a bit of fun to your outfit.",
    image: 'https://scampanddude.com/cdn/shop/files/AdultsOversizedShirtBlueandWhiteMixandMatchStripe_0866.png?v=1742480450&width=5000',
    rating: 4.9,
    reviewCount: 45,
    tags: ['Stripes'],
    url: 'https://go.shopmy.us/p-40018082',
    inStock: true,
    company: 'Scamp and Dude'
  },
  {
    id: 'fashion-new-5',
    name: "Skirt (Patterned)",
    category: 'Fashion',
    price: 58.00,
    description: "A beautiful pattern that makes a statement. I just love the vibrant colors, darling!",
    image: 'https://scampanddude.com/cdn/shop/files/SCAMPANDDUDE_ECOM_DAY_194693.jpg?v=1753365162&width=5000',
    rating: 4.8,
    reviewCount: 38,
    tags: ['Patterns'],
    url: 'https://go.shopmy.us/p-40018043',
    inStock: true,
    company: 'Scamp and Dude'
  },
  {
    id: 'fashion-new-6',
    name: "Skirt (Commense)",
    category: 'Fashion',
    price: 48.00,
    description: "Modern and stylish. This skirt from The Commense is a real head-turner!",
    image: 'https://thecommense.com/cdn/shop/files/B1731660076792_4fce9a09-c4df-4a7f-a37d-1e59d2ad3100_1800x1800.jpg?v=1763460121',
    rating: 4.7,
    reviewCount: 52,
    tags: ['Modern'],
    url: 'https://go.shopmy.us/p-40039460',
    inStock: true,
    company: 'Commense'
  },
  {
    id: 'fashion-new-7',
    name: "Cosy Socks",
    category: 'Fashion',
    price: 9.50,
    description: "Keep those toes warm while you're whizzing around! These cosy ankle-high socks are just lovely.",
    image: 'https://assets.digitalcontent.marksandspencer.app/images/w_1024,q_auto,f_auto/SD_02_T60_9614H_N4_X_EC_90/2pk-Cosy-Ankle-High-Socks',
    rating: 4.9,
    reviewCount: 520,
    tags: ['Cosy'],
    url: 'https://go.shopmy.us/p-39340179',
    inStock: true,
    company: 'M & S'
  },
  {
    id: 'fashion-new-8',
    name: "Animal Barrel Jeans",
    category: 'Fashion',
    price: 45.00,
    description: "Add a bit of edge to your look with these mid-rise animal print jeans. So stylish and comfortable!",
    image: 'https://assets.digitalcontent.marksandspencer.app/images/w_1024,q_auto,f_auto/SD_01_T57_6077_NU_X_EC_90/Mid-Rise-Animal-Barrel-Jeans',
    rating: 4.8,
    reviewCount: 89,
    tags: ['Denim', 'Animal Print'],
    url: 'https://go.shopmy.us/p-39255174',
    inStock: true,
    company: 'M & S'
  },
  {
    id: 'fashion-new-9',
    name: "Barrel Jeans",
    category: 'Fashion',
    price: 42.00,
    description: "The perfect fit! These mid-rise barrel jeans are great for everyday wear.",
    image: 'https://assets.digitalcontent.marksandspencer.app/images/w_1024,q_auto,f_auto/SD_01_T57_9686_O4_X_EC_90/Mid-Rise-Barrel-Jeans',
    rating: 4.7,
    reviewCount: 145,
    tags: ['Denim'],
    url: 'https://go.shopmy.us/p-39255413',
    inStock: true,
    company: 'M & S'
  },
  {
    id: 'fashion-new-10',
    name: "Block Heel Loafers",
    category: 'Fashion',
    price: 59.00,
    description: "Smart, sophisticated, and surprisingly comfortable. Perfect for a busy day on your feet!",
    image: 'https://assets.digitalcontent.marksandspencer.app/images/w_1024,q_auto,f_auto/SD_01_T02_3799_N0_X_EC_90/Leather-Trim-Block-Heel-Loafers',
    rating: 4.9,
    reviewCount: 76,
    tags: ['Shoes'],
    url: 'https://go.shopmy.us/p-39255304',
    inStock: true,
    company: 'M & S'
  },
  {
    id: 'fashion-new-11',
    name: "Crossbody Bag",
    category: 'Fashion',
    price: 35.00,
    description: "Keep your essentials handy with this stylish bag. I love the clean lines, darling!",
    image: 'https://cdn.shopify.com/s/files/1/0560/4425/files/cms-pm-gallery-20241-125-684-450-O1tuEZWkTbSrjT185rZ73g_1b647601-1fd7-4216-b75b-0a0c1ba5f0a1.jpg?v=1769680969',
    rating: 4.8,
    reviewCount: 92,
    tags: ['Accessories'],
    url: 'https://go.shopmy.us/p-39254946',
    inStock: true,
    company: 'Strathberry'
  },
  {
    id: 'fashion-new-12',
    name: "Longline Car Coat",
    category: 'Fashion',
    price: 89.00,
    description: "Stay warm and look fabulous in this brushed collared coat with wool. A classic piece, love.",
    image: 'https://assets.digitalcontent.marksandspencer.app/images/w_1024,q_auto,f_auto/SD_01_T59_8736C_A0_X_EC_90/Brushed-Collared-Longline-Car-Coat-with-Wool',
    rating: 5.0,
    reviewCount: 42,
    tags: ['Outerwear'],
    url: 'https://go.shopmy.us/p-39255538',
    inStock: true,
    company: 'M & S'
  },
  {
    id: 'fashion-new-13',
    name: "Striped Cotton Shirt",
    category: 'Fashion',
    price: 25.00,
    description: "Pure cotton and perfectly striped. This shirt is breathable and so easy to style.",
    image: 'https://assets.digitalcontent.marksandspencer.app/images/w_1024,q_auto,f_auto/SD_01_T43_0048R_A4_X_EC_90/Pure-Cotton-Striped-Shirt',
    rating: 4.7,
    reviewCount: 180,
    tags: ['Cotton'],
    url: 'https://go.shopmy.us/p-39255656',
    inStock: true,
    company: 'M & S'
  },
  {
    id: 'fashion-new-14',
    name: "Frill Collar Shirt",
    category: 'Fashion',
    price: 32.00,
    description: "A delicate frill collar adds such a feminine touch. Simply gorgeous with jeans!",
    image: 'https://assets.digitalcontent.marksandspencer.app/images/w_1024,q_auto,f_auto/SD_01_T53_2592U_J4_X_EC_90/Cotton-Blend-Striped-Frill-Collar-Shirt',
    rating: 4.8,
    reviewCount: 64,
    tags: ['Feminine'],
    url: 'https://go.shopmy.us/p-39255860',
    inStock: true,
    company: 'M & S'
  },
  {
    id: 'fashion-new-15',
    name: "Faux Fur Jacket",
    category: 'Fashion',
    price: 75.00,
    description: "Add some texture and warmth with this collarless short jacket. It feels like a hug!",
    image: 'https://assets.digitalcontent.marksandspencer.app/images/w_1024,q_auto,f_auto/SD_01_T49_8081_L0_X_EC_90/Faux-Fur-Textured-Collarless-Short-Jacket',
    rating: 4.9,
    reviewCount: 28,
    tags: ['Fur', 'Outerwear'],
    url: 'https://go.shopmy.us/p-39256145',
    inStock: true,
    company: 'M & S'
  },
  {
    id: 'fashion-new-16',
    name: "Relaxed Funnel Jumper",
    category: 'Fashion',
    price: 38.00,
    description: "Cloud yarn for ultimate softness. This relaxed jumper is my go-to for chillier days.",
    image: 'https://assets.digitalcontent.marksandspencer.app/images/w_1024,q_auto,f_auto/SD_01_T38_9079_XH_X_EC_90/Cloud-Yarn-Textured-Funnel-Neck-Relaxed-Jumper',
    rating: 4.8,
    reviewCount: 156,
    tags: ['Cozy'],
    url: 'https://go.shopmy.us/p-39256223',
    inStock: true,
    company: 'M & S'
  },
  {
    id: 'fashion-new-17',
    name: "Graphic Tshirt",
    category: 'Fashion',
    price: 22.00,
    description: "Another fantastic Scamp & Dude design! Fun, vibrant, and looks great washed time after time.",
    image: 'https://scampanddude.com/cdn/shop/files/SCAMPANDDUDE_ECOM_JAN26_1148.jpg?v=1768577178&width=5000',
    rating: 4.7,
    reviewCount: 84,
    tags: ['Scamp & Dude'],
    url: 'https://go.shopmy.us/p-39327948',
    inStock: true,
    company: 'Scamp and Dude'
  },
  {
    id: 'fashion-new-18',
    name: "Cardigan",
    category: 'Fashion',
    price: 28.00,
    description: "A versatile layering piece. Perfect for those in-between weather days.",
    image: 'https://m.media-amazon.com/images/I/71TDn88KHFL._AC_SX679_.jpg',
    rating: 4.6,
    reviewCount: 340,
    tags: ['Knitwear'],
    url: 'https://amzlink.to/az08250w52vqX',
    inStock: true,
    company: 'Amazon',
    asin: 'B0DG8K8TL1'
  },
  {
    id: 'fashion-new-19',
    name: "White Tshirt",
    category: 'Fashion',
    price: 15.00,
    description: "A classic white tee that stays bright! High quality cotton that feels so soft.",
    image: 'https://m.media-amazon.com/images/I/51KDdRSbH0L._AC_SX569_.jpg',
    rating: 4.8,
    reviewCount: 1200,
    tags: ['Essentials'],
    url: 'https://amzlink.to/az0zMJcj3bd3j',
    inStock: true,
    company: 'Amazon',
    asin: 'B0B3JMTTKX'
  },
  {
    id: 'fashion-new-20',
    name: "Trainers",
    category: 'Fashion',
    price: 45.00,
    description: "Comfort meets style! These trainers are perfect for getting your steps in while looking great.",
    image: 'https://m.media-amazon.com/images/I/71HKUTvq2eL._AC_SX695_.jpg',
    rating: 4.9,
    reviewCount: 420,
    tags: ['Shoes'],
    url: 'https://amzlink.to/az0A0pe9AhO0j',
    inStock: true,
    company: 'Amazon',
    asin: 'B0DHWQC2LS'
  },
  {
    id: 'fashion-new-21',
    name: "Yellow Jumper",
    category: 'Fashion',
    price: 35.00,
    description: "Bring a bit of sunshine into your home with this bright yellow jumper! Simply lovely.",
    image: 'https://m.media-amazon.com/images/I/81p0GVaL9hL._AC_SY741_.jpg',
    rating: 4.8,
    reviewCount: 65,
    tags: ['Bright'],
    url: 'https://amzn.to/4bXu7nA',
    inStock: true,
    company: 'Amazon',
    asin: 'B0DJNV17CY'
  },
  {
    id: 'fashion-new-22',
    name: "Striped Grey Jumper",
    category: 'Fashion',
    price: 36.00,
    description: "Classic stripes in a versatile grey. Looks so chic with leggings or jeans.",
    image: 'https://m.media-amazon.com/images/I/716oO97rDrL._AC_SY741_.jpg',
    rating: 4.7,
    reviewCount: 92,
    tags: ['Stripes'],
    url: 'https://amzlink.to/az08bqnlIPo1X',
    inStock: true,
    company: 'Amazon',
    asin: 'B0DGY4GLQR'
  },
  {
    id: 'fashion-new-23',
    name: "Cable Knit Jumper",
    category: 'Fashion',
    price: 42.00,
    description: "Traditional cable knit for a timeless look. So warm and well-made.",
    image: 'https://m.media-amazon.com/images/I/71haKU0LWFL._AC_SY879_.jpg',
    rating: 4.9,
    reviewCount: 110,
    tags: ['Classic'],
    url: 'https://amzn.to/3My7WtI',
    inStock: true,
    company: 'Amazon',
    asin: 'B0DZNVWSBT'
  },
  {
    id: 'fashion-new-24',
    name: "Star PJ'S",
    category: 'Fashion',
    price: 24.00,
    description: "Sweet dreams start here! These star pattern PJs are soft, stretchy, and so cute.",
    image: 'https://m.media-amazon.com/images/I/712tIrb1tsL._AC_SY879_.jpg',
    rating: 4.9,
    reviewCount: 245,
    tags: ['Nightwear'],
    url: 'https://amzlink.to/az0h9QgeiJEp0',
    inStock: true,
    company: 'Amazon',
    asin: 'B0FKGQMG3G'
  },
  {
    id: 'fashion-new-25',
    name: "Slippers",
    category: 'Fashion',
    price: 18.00,
    description: "The ultimate treat for your feet! Fluffy, warm, and perfect for relaxing.",
    image: 'https://m.media-amazon.com/images/I/71yhTG8TNrL._AC_SY695_.jpg',
    rating: 4.8,
    reviewCount: 630,
    tags: ['Shoes', 'Home'],
    url: 'https://amzn.to/4tDdi7v',
    inStock: true,
    company: 'Amazon',
    asin: 'B0BYNWKBJF'
  },
  {
    id: 'fashion-new-26',
    name: "Patterned PJ's",
    category: 'Fashion',
    price: 26.00,
    description: "Another gorgeous set for a comfortable night's sleep. Simply lovely quality.",
    image: 'https://m.media-amazon.com/images/I/71jBU3TMGnL._AC_SY741_.jpg',
    rating: 4.7,
    reviewCount: 89,
    tags: ['Nightwear'],
    url: 'https://amzlink.to/az05VOsKs58H8',
    inStock: true,
    company: 'Amazon',
    asin: 'B0BVBC615H'
  },
  {
    id: 'fashion-new-27',
    name: "Large Tote Bag",
    category: 'Fashion',
    price: 38.00,
    description: "Fits everything you need for a busy day out! Durable and so practical, love.",
    image: 'https://m.media-amazon.com/images/I/81B5ImGAbQL._AC_SX625_.jpg',
    rating: 4.8,
    reviewCount: 112,
    tags: ['Bag'],
    url: 'https://amzlink.to/az05aVHKM0uGH',
    inStock: true,
    company: 'Amazon',
    asin: 'B0D39Z5GD4'
  },
  {
    id: 'fashion-new-28',
    name: "Leggings",
    category: 'Fashion',
    price: 18.00,
    description: "Opaque, comfortable, and they stay up! The perfect base for any casual look.",
    image: 'https://m.media-amazon.com/images/I/41XfiPpA5sL._AC_SX679_.jpg',
    rating: 4.9,
    reviewCount: 2400,
    tags: ['Essentials'],
    url: 'https://amzlink.to/az0Ry2VniV92X',
    inStock: true,
    company: 'Amazon',
    asin: 'B0D5ZNDRGQ'
  },
  {
    id: 'fashion-new-29',
    name: "Winter Gloves",
    category: 'Fashion',
    price: 12.00,
    description: "Keep the cold at bay with these warm winter gloves. Soft and cosy!",
    image: 'https://m.media-amazon.com/images/I/71xS0Xn0NfL._AC_SX679_.jpg',
    rating: 4.6,
    reviewCount: 185,
    tags: ['Accessories'],
    url: 'https://amzlink.to/az09GYSHu8kCS',
    inStock: true,
    company: 'Amazon',
    asin: 'B08FDH654K'
  },

  // HOME
  {
    id: 'home-1',
    name: "Self Adhesive Hooks",
    category: 'Home',
    price: 5.99,
    description: "No drills, no fuss! These hooks are a life-saver for keeping things organized without the mess.",
    image: 'https://m.media-amazon.com/images/I/61qKWKX3auL._AC_SX679_.jpg',
    rating: 4.6,
    reviewCount: 1500,
    tags: ['Handy'],
    url: 'https://amzlink.to/az0uhk6dRTIBn',
    inStock: true,
    company: 'Amazon',
    asin: 'B0BTPJWHW5'
  },

  // STORAGE
  {
    id: 'storage-1',
    name: "12 Pack Drawer Organisers",
    category: 'Storage',
    price: 18.99,
    description: "A place for everything and everything in its place. These make my heart so happy, love!",
    image: 'https://m.media-amazon.com/images/I/81G8Kg1IIOL._AC_SX679_.jpg',
    rating: 4.9,
    reviewCount: 940,
    tags: ['Organize'],
    url: 'https://amzlink.to/az0xXb7ZKm2LL',
    inStock: true,
    company: 'Amazon',
    asin: 'B0B7VLWYS8'
  },

  // SUPPLEMENTS
  {
    id: 'supps-1',
    name: "TRIP Magnesium Gummies",
    category: 'Supplements',
    price: 20.00,
    description: "Relax and unwind after a busy day. These are a little treat for your well-being.",
    image: 'https://m.media-amazon.com/images/I/71GhSDshKrL._AC_SX425_.jpg',
    rating: 4.8,
    reviewCount: 560,
    tags: ['Wellness'],
    url: 'https://amzlink.to/az0F0EGl59xtI',
    inStock: true,
    company: 'Amazon',
    asin: 'B0DCJZPFZV'
  },

  // HOME INTERIORS
  {
    id: 'int-1',
    name: "Curtains",
    category: 'Home Interiors',
    price: 55.00,
    description: "Elegant curtains that frame your windows and add such a warm touch to any room.",
    image: 'https://m.media-amazon.com/images/I/617R9gsBAeL._AC_SX679_.jpg',
    rating: 4.7,
    reviewCount: 312,
    tags: ['Interiors'],
    url: 'https://amzlink.to/az0EppZr07JAm',
    inStock: true,
    company: 'Amazon',
    asin: 'B09PQG822M'
  },
  {
    id: 'int-2',
    name: "Dunelm Bedding",
    category: 'Home Interiors',
    price: 45.00,
    description: "Transform your bedroom into a sanctuary with this beautiful bedding set from Dunelm.",
    image: 'https://images.dunelm.com/31028387.jpg?$standardplayerzoom$&img404=noimagedefault',
    rating: 4.9,
    reviewCount: 240,
    tags: ['Sanctuary', 'Dunelm'],
    url: 'https://dunelm.mtpc.se/5944635',
    inStock: true,
    company: 'Dunelm'
  },
  {
    id: 'int-3',
    name: "Velvet Cushion",
    category: 'Home Interiors',
    price: 12.00,
    description: "Add a touch of luxury to your sofa with this soft velvet cushion. Simply divine!",
    image: 'https://images.dunelm.com/30605808.jpg?$standardplayerzoom$&img404=noimagedefault',
    rating: 4.8,
    reviewCount: 156,
    tags: ['Luxury', 'Cushion'],
    url: 'https://dunelm.mtpc.se/5938730',
    inStock: true,
    company: 'Dunelm'
  },
  {
    id: 'int-4',
    name: "Grey Bedding Set",
    category: 'Home Interiors',
    price: 32.00,
    description: "A classic and versatile bedding set. Easy to wash and keeps your bedroom looking fresh.",
    image: 'https://m.media-amazon.com/images/I/811QXARp7sL._AC_SL1500_.jpg',
    rating: 4.7,
    reviewCount: 890,
    tags: ['Classic', 'Essentials'],
    url: 'https://amzlink.to/az0HjhU6cZdl7',
    inStock: true,
    company: 'Amazon',
    asin: 'B078RJX3CC'
  },
  {
    id: 'int-5',
    name: "Mattress Protector",
    category: 'Home Interiors',
    price: 15.00,
    description: "Protect your investment! This mattress protector is essential for a clean sleep environment.",
    image: 'https://m.media-amazon.com/images/I/81sTERnIUOL._AC_SL1500_.jpg',
    rating: 4.9,
    reviewCount: 1200,
    tags: ['Hygienic', 'Protection'],
    url: 'https://amzlink.to/az0kW4Qi0p3gi',
    inStock: true,
    company: 'Amazon',
    asin: 'B07FMB7LYP'
  },
  {
    id: 'int-6',
    name: "Fitted Sheet",
    category: 'Home Interiors',
    price: 10.00,
    description: "High-quality fitted sheet that stays in place. Soft, durable, and so easy to care for.",
    image: 'https://m.media-amazon.com/images/I/81V2xbtQdGL._AC_SL1500_.jpg',
    rating: 4.8,
    reviewCount: 3400,
    tags: ['Basics', 'Quality'],
    url: 'https://amzlink.to/az00YLPpPh7Kp',
    inStock: true,
    company: 'Amazon',
    asin: 'B0BVMJVTH9'
  },
  {
    id: 'int-7',
    name: "Egyptian Cotton Towels",
    category: 'Home Interiors',
    price: 25.00,
    description: "Luxury for your bathroom! These fluffy towels are super absorbent and feel so soft.",
    image: 'https://m.media-amazon.com/images/I/71T--nxZKdL._AC_SL1500_.jpg',
    rating: 4.9,
    reviewCount: 620,
    tags: ['Luxury', 'Bathroom'],
    url: 'https://amzlink.to/az0aYNt0nfV93',
    inStock: true,
    company: 'Amazon',
    asin: 'B07SMTW9GP'
  },
  {
    id: 'int-8',
    name: "Floral Bedding",
    category: 'Home Interiors',
    price: 35.00,
    description: "Bring the outside in with this beautiful floral bedding set. Cheerful and lovely.",
    image: 'https://m.media-amazon.com/images/I/91YiUO93zBL._AC_SL1500_.jpg',
    rating: 4.8,
    reviewCount: 310,
    tags: ['Floral', 'Cheerful'],
    url: 'https://amzlink.to/az0jo6JKySxP8',
    inStock: true,
    company: 'Amazon',
    asin: 'B0DMWMV2SB'
  },
  {
    id: 'int-9',
    name: "Velvet Occasional Chair",
    category: 'Home Interiors',
    price: 145.00,
    description: "A real statement piece! This elegant chair is both stylish and comfortable.",
    image: 'https://m.media-amazon.com/images/I/71Oy8Ud828L._AC_SL1500_.jpg',
    rating: 5.0,
    reviewCount: 45,
    tags: ['Statement', 'Furniture'],
    url: 'https://amzlink.to/az0D3QJ6qbOsN',
    inStock: true,
    company: 'Amazon',
    asin: 'B0D96BYR28'
  },
  {
    id: 'int-10',
    name: "Power Shower Head",
    category: 'Home Interiors',
    price: 22.00,
    description: "Upgrade your morning routine! This shower head provides great pressure.",
    image: 'https://m.media-amazon.com/images/I/81WlEJrx1rL._AC_SL1500_.jpg',
    rating: 4.7,
    reviewCount: 520,
    tags: ['Bathroom', 'Efficiency'],
    url: 'https://amzlink.to/az00xt5PaxRJJ',
    inStock: true,
    company: 'Amazon',
    asin: 'B0CSZ1FD2N'
  },
  {
    id: 'int-11',
    name: "Fleece Throw Blanket",
    category: 'Home Interiors',
    price: 18.00,
    description: "The ultimate cozy companion. Perfect for snuggling up on the sofa.",
    image: 'https://m.media-amazon.com/images/I/71+4lvpo5qL._AC_SL1500_.jpg',
    rating: 4.9,
    reviewCount: 1100,
    tags: ['Cozy', 'Essentials'],
    url: 'https://amzlink.to/az0yqUe0L58oY',
    inStock: true,
    company: 'Amazon',
    asin: 'B084WT848W'
  },
  {
    id: 'int-12',
    name: "Scented Candle",
    category: 'Home Interiors',
    price: 14.00,
    description: "Create a relaxing atmosphere with this beautifully scented candle. Smells divine!",
    image: 'https://m.media-amazon.com/images/I/61YDqf9SHgL._AC_SL1500_.jpg',
    rating: 4.8,
    reviewCount: 430,
    tags: ['Aroma', 'Relaxation'],
    url: 'https://amzlink.to/az0VSRuYB9eIL',
    inStock: true,
    company: 'Amazon',
    asin: 'B00LC6NV4I'
  },
  {
    id: 'int-13',
    name: "Echo Dot",
    category: 'Home Interiors',
    price: 44.99,
    description: "Your smart home assistant! Set timers for cleaning and play your favourite tunes.",
    image: 'https://m.media-amazon.com/images/I/71K1KFhR+xL._AC_SL1500_.jpg',
    rating: 4.9,
    reviewCount: 8900,
    tags: ['Smart Home', 'Tech'],
    url: 'https://amzlink.to/az0PAXQ2VGfQM',
    inStock: true,
    company: 'Amazon',
    asin: 'B09B96TG33'
  },

  // MY RANGE
  {
    id: 'swan-1',
    name: "Cordless Handheld Vacuum",
    category: 'My Range',
    price: 79.99,
    description: "Perfect for those quick whizzes around the house, darling! Lightweight, powerful, and always ready for action.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052416436-YJ26NQD0W8GZ6474VC5Q/fit.webp?format=500w',
    rating: 4.9,
    reviewCount: 1250,
    tags: ['Best Seller', 'Cordless'],
    url: 'https://shop.swan-brand.co.uk/cordless-vacuum-cleaners/lynseys-cleaning-range-cordless-handheld-vacuum',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-2',
    name: "1.3 Litre Spot Cleaner",
    category: 'My Range',
    price: 89.99,
    description: "Lift stubborn spots and spills in an instant. This little gem is a life-saver for carpets and upholstery!",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052942117-N2OOGAM1ABOCJ65KANRZ/fit+%281%29.webp?format=750w',
    rating: 4.8,
    reviewCount: 840,
    tags: ['Spot Clean', 'Portable'],
    url: 'https://shop.swan-brand.co.uk/upright-vacuum-cleaners/lynseys-cleaning-range-spot-cleaner',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-3',
    name: "Cordless Window Vacuum",
    category: 'My Range',
    price: 39.99,
    description: "Streak-free windows in minutes! Say goodbye to paper towels and hello to a professional shine.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052942107-XYMYYJ9LSDLYN82UZPTU/fit+%282%29.webp?format=750w',
    rating: 4.7,
    reviewCount: 620,
    tags: ['Windows', 'Glass'],
    url: 'https://shop.swan-brand.co.uk/cordless-vacuum-cleaners/lynseys-cleaning-range-cordless-window-vacuum',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-4',
    name: "29.6V Cordless Anti-Tangle Vacuum",
    category: 'My Range',
    price: 149.99,
    description: "Power and precision combined. The anti-tangle brush is a dream for pet owners and long hair alike.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052943177-46GUZNR52SNHB56B6YUA/fit+%283%29.webp?format=750w',
    rating: 4.9,
    reviewCount: 310,
    tags: ['Anti-Tangle', 'Powerful'],
    url: 'https://shop.swan-brand.co.uk/cordless-vacuum-cleaners/lynseys-cleaning-range-296v-cordless-anti-tangle-vacuum',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-5',
    name: "Cordless Handheld Vacuum and Steam Cleaner Set",
    category: 'My Range',
    price: 129.99,
    description: "The ultimate cleaning duo. Everything you need to keep your surfaces sanitized and sparkling.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052943306-CQW8IB25U81BSAW6GCDN/fit+%284%29.webp?format=750w',
    rating: 4.8,
    reviewCount: 180,
    tags: ['Bundle', 'Steam'],
    url: 'https://shop.swan-brand.co.uk/floorcare/lynseys-cleaning-range-cordless-handheld-vacuum-and-steam-cleaner-set',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-6',
    name: "Cordless Handheld Vacuum and 16-in-1 Steam Mop Bundle",
    category: 'My Range',
    price: 159.99,
    description: "Complete floor-to-ceiling cleaning. This bundle covers every nook and cranny of your home.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052415470-ZDX7I7I63QGOCPCHMG9K/Cordless+Handheld+Vacuum+and+16-in-1+Steam+Mop+Bundle.png?format=750w',
    rating: 4.9,
    reviewCount: 420,
    tags: ['Complete', 'Mop'],
    url: 'https://shop.swan-brand.co.uk/floorcare/lynseys-cleaning-range-cordless-handheld-vacuum-and-16-in-1-steam-mop-bundle',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-7',
    name: "Cordless Handheld and Window Vacuum Bundle",
    category: 'My Range',
    price: 99.99,
    description: "Clean surfaces and streak-free windows. A fantastic set for maintaining a bright, airy home.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052944258-S9F01CWXZAYL3YVA9U45/fit+%285%29.webp?format=750w',
    rating: 4.7,
    reviewCount: 245,
    tags: ['Bundle', 'Surface Care'],
    url: 'https://shop.swan-brand.co.uk/floorcare/lynseys-cleaning-range-cordless-handheld-vacuum-and-steam-cleaner-bundle',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-8',
    name: "Cylinder Multi-Cyclonic Pet Vacuum Cleaner",
    category: 'My Range',
    price: 119.99,
    description: "Engineered for pet hair and deep carpet cleaning. Robust power in a compact cylinder design.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768054623106-CEKGDGBU9Z1SPWFH26MY/fit+%2825%29.webp?format=750w',
    rating: 4.8,
    reviewCount: 380,
    tags: ['Pet Care', 'Cyclonic'],
    url: 'https://shop.swan-brand.co.uk/vacuums/lynsey-cleaning-range-cylinder-pet-vacuum-cleaner',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-9',
    name: "Cordless Anti-Tangle Vacuum",
    category: 'My Range',
    price: 139.99,
    description: "Effortless cleaning without the cord or the tangles. Versatile and lightweight for everyday whizzing!",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052943177-46GUZNR52SNHB56B6YUA/fit+%283%29.webp?format=750w',
    rating: 4.8,
    reviewCount: 560,
    tags: ['Anti-Tangle', 'Lightweight'],
    url: 'https://shop.swan-brand.co.uk/cordless-vacuum-cleaners/lynseys-cleaning-range-cordless-anti-tangle-vacuum-cleaner',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-10',
    name: "Collapsible Laundry Basket",
    category: 'My Range',
    price: 19.99,
    description: "Space-saving and stylish. Simply pop it down when you're done—perfect for tidy homes, love!",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052947603-A56YVMY51R79G6ZZZS11/fit+%2815%29.webp?format=750w',
    rating: 4.9,
    reviewCount: 1100,
    tags: ['Laundry', 'Space Saving'],
    url: 'https://shop.swan-brand.co.uk/laundry-baskets/lynseys-cleaning-range-collapsible-laundry-basket',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-11',
    name: "Ironing Board",
    category: 'My Range',
    price: 49.99,
    description: "Solid, stable, and designed for comfort. Makes the ironing chore feel a whole lot easier.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052947450-C33AYRH29NHJ1ZI54BC6/fit+%2816%29.webp?format=750w',
    rating: 4.8,
    reviewCount: 320,
    tags: ['Laundry', 'Stable'],
    url: 'https://shop.swan-brand.co.uk/ironing-boards/lynseys-cleaning-range-ironing-board',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-12',
    name: "Spin Mop",
    category: 'My Range',
    price: 34.99,
    description: "Effortless floor cleaning with the ultimate spin action. Gets right into the corners!",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052946582-GB41TUCSSE7EAURLR2PK/fit+%2817%29.webp?format=750w',
    rating: 4.8,
    reviewCount: 890,
    tags: ['Floors', 'Mop'],
    url: 'https://shop.swan-brand.co.uk/floor-cleaners/lynseys-cleaning-range-spin-mop',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-13',
    name: "Carpet Washer Solution",
    category: 'My Range',
    price: 14.99,
    description: "Refresh and revive your carpets. This professional solution lifts dirt and leaves a lovely fresh scent.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052950820-VZM3WWW70LB6OBPLY9TU/fit+%2818%29.webp?format=750w',
    rating: 4.9,
    reviewCount: 2100,
    tags: ['Carpets', 'Solution'],
    url: 'https://shop.swan-brand.co.uk/floorcare-spares/lynseys-range-carpet-washer-solution',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-14',
    name: "Toilet Brush",
    category: 'My Range',
    price: 12.99,
    description: "Elegantly designed and highly effective. Keep your bathroom sparkling with this range essential.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052951027-HSD3VBLQKFM4TZVXJ7BK/fit+%2819%29.webp?format=750w',
    rating: 4.6,
    reviewCount: 450,
    tags: ['Bathroom', 'Clean'],
    url: 'https://shop.swan-brand.co.uk/cleaning/lynseys-cleaning-range-toilet-brush',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-15',
    name: "Carpet Washer",
    category: 'My Range',
    price: 129.99,
    description: "Professional-grade results at home. Deep clean your carpets and see them look brand new again!",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052951899-HCZE4H7GAADNVS3HGOW1/fit+%2820%29.webp?format=750w',
    rating: 4.9,
    reviewCount: 156,
    tags: ['Deep Clean', 'Carpets'],
    url: 'https://shop.swan-brand.co.uk/upright-vacuum-cleaners/lynseys-cleaning-range-carpet-washer',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-16',
    name: "Spray Mop",
    category: 'My Range',
    price: 24.99,
    description: "Quick and easy floor maintenance. Just spray and wipe for a sparkling finish every day.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052952152-TDUBZW11V14T35HKQ5HZ/fit+%2821%29.webp?format=750w',
    rating: 4.8,
    reviewCount: 1240,
    tags: ['Floors', 'Quick Clean'],
    url: 'https://shop.swan-brand.co.uk/floor-cleaners/lynseys-cleaning-range-spray-mop',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-17',
    name: "Lamb Wool Dryer Balls",
    category: 'My Range',
    price: 12.50,
    description: "Reduce drying time and soften your laundry naturally. An eco-friendly alternative to softener sheets.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052952880-M89ICJAXBGXB4KTIYXQI/fit+%2822%29.webp?format=750w',
    rating: 5.0,
    reviewCount: 630,
    tags: ['Laundry', 'Eco Friendly'],
    url: 'https://shop.swan-brand.co.uk/laundry-baskets/lynseys-cleaning-range-lambs-wool-dryer-balls',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-18',
    name: "Handheld Carpet Cleaner",
    category: 'My Range',
    price: 59.99,
    description: "Perfect for spot cleaning stairs, rugs, and car interiors. Compact power right in your hand!",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052415327-4WX64AF3QHIOIT016974/carpetcleanerimage1-1.jpg?format=750w',
    rating: 4.7,
    reviewCount: 290,
    tags: ['Portable', 'Carpets'],
    url: 'https://shop.swan-brand.co.uk/carpet-washers/lynseys-range-handheld-carpet-cleaner',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-19',
    name: "Handheld Steam Cleaner",
    category: 'My Range',
    price: 44.99,
    description: "Sanitize surfaces naturally with the power of steam. Kills bacteria and removes grease with ease.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768053365409-LOK4953VENUOHJVUV2GY/fit+%2824%29.webp?format=750w',
    rating: 4.8,
    reviewCount: 510,
    tags: ['Sanitize', 'Steam'],
    url: 'https://shop.swan-brand.co.uk/steam-cleaners/lynseys-range-handheld-steam-cleaner',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-20',
    name: "Laundry Bundle",
    category: 'My Range',
    price: 89.99,
    description: "Everything you need for a professional laundry routine. From basket to dryer balls, I've got you covered.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768396022502-WCLN9BZV1VF8ZOLLQEDR/Laundry+Bundle.png?format=750w',
    rating: 4.9,
    reviewCount: 120,
    tags: ['Bundle', 'Laundry'],
    url: 'https://shop.swan-brand.co.uk/laundry/lynseys-cleaning-range-laundry-bundle',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-21',
    name: "16-in-1 Steam Mop",
    category: 'My Range',
    price: 79.99,
    description: "The most versatile mop you'll ever own. Converts to a handheld for every cleaning task imaginable.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052945464-F0FMPWVC8A64ESADQCUJ/fit+%289%29.webp?format=750w',
    rating: 4.9,
    reviewCount: 1560,
    tags: ['Versatile', 'Steam'],
    url: 'https://shop.swan-brand.co.uk/floor-cleaners/lynseys-cleaning-range-16-in-1-steam-mop',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-22',
    name: "Monster Laundry Bag 2pk",
    category: 'My Range',
    price: 22.99,
    description: "Huge capacity for busy families. These robust bags make hauling laundry simple and tidy.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052946410-FSRIMM7I6275AGOZ0QJP/fit+%2810%29.webp?format=750w',
    rating: 4.8,
    reviewCount: 340,
    tags: ['Laundry', 'Capacity'],
    url: 'https://shop.swan-brand.co.uk/laundry-baskets/lynseys-cleaning-range-monster-laundry-bag-2pk',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-23',
    name: "Ironing Board Cover",
    category: 'My Range',
    price: 12.99,
    description: "Protect your board and brighten your room with my signature crowns design. Lovely quality, darling!",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768396172396-1C7A5Q82IJALOKMV01UZ/Ironing+Board+Cover.webp?format=750w',
    rating: 4.7,
    reviewCount: 180,
    tags: ['Laundry', 'Style'],
    url: 'https://shop.swan-brand.co.uk/ironing-boards/lynseys-cleaning-range-ironing-board-cover-crowns',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-24',
    name: "Hardfloor Cleaner and Polisher",
    category: 'My Range',
    price: 99.99,
    description: "Give your hard floors a professional shine. Cleans and polishes in one easy movement.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052949680-JCAXOL7EFN151N18FVPB/fit+%2812%29.webp?format=750w',
    rating: 4.8,
    reviewCount: 220,
    tags: ['Floors', 'Polish'],
    url: 'https://shop.swan-brand.co.uk/floor-cleaners/lynseys-cleaning-range-hardfloor-cleaner-and-polisher',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-25',
    name: "5 in 1 Spin Scrubber",
    category: 'My Range',
    price: 49.99,
    description: "Take the effort out of scrubbing! This powerful spin tool handles grout, tiles, and ovens with ease.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052948716-PZI6SRINGHGV2CGNG9BZ/fit+%2813%29.webp?format=750w',
    rating: 4.9,
    reviewCount: 740,
    tags: ['Scrub', 'Versatile'],
    url: 'https://shop.swan-brand.co.uk/cleaning/lynseys-cleaning-range-5-in-1-spin-scrubber',
    inStock: true,
    company: 'Swan'
  },
  {
    id: 'swan-26',
    name: "2-in-1 Expandable Microfibre Duster",
    category: 'My Range',
    price: 14.99,
    description: "Reach every high spot and corner. The microfibre head traps dust for a truly professional clean.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052948432-OXSU165RUEBPL9RL5W6O/fit+%2814%29.webp?format=750w',
    rating: 4.8,
    reviewCount: 560,
    tags: ['Dusting', 'Reach'],
    url: 'https://shop.swan-brand.co.uk/cleaning/lynseys-cleaning-range-2-in-1-expandable-microfibre-duster',
    inStock: true,
    company: 'Swan'
  }
];

export const CATEGORIES: string[] = [
  'All',
  'Lynsey Favorites',
  'Books',
  'Cleaning Tools',
  'Home Interiors',
  'Fashion',
  'Make Up',
  'Home',
  'Storage',
  'Supplements',
  'My Range'
];
